/**
 * Newsletter popup: once per browser session unless form errors require resubmit.
 * Flow: tag customers with popup-welcome (see hidden input in snippet).
 */
(function () {
  const STORAGE_KEY = 'chic_newsletter_popup_session';
  const OPEN_CLASS = 'chic-newsletter-popup--open';
  const OPEN_DELAY_MS = 500;

  function isDesignMode() {
    return document.documentElement.classList.contains('shopify-design-mode');
  }

  function shouldMarkSubmittedFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true'
    );
  }

  function lockScroll() {
    const y = window.scrollY;
    document.body.dataset.newsletterPopupScrollY = String(y);
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${y}px`;
  }

  function unlockScroll() {
    const y = document.body.dataset.newsletterPopupScrollY;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    delete document.body.dataset.newsletterPopupScrollY;
    if (y != null) window.scrollTo(0, parseInt(y, 10) || 0);
  }

  function openPopup(root) {
    if (!root || root.classList.contains(OPEN_CLASS)) return;
    root.classList.add(OPEN_CLASS);
    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');
    lockScroll();
    const input = root.querySelector('.chic-newsletter-popup__input');
    if (input) {
      requestAnimationFrame(() => input.focus({ preventScroll: true }));
    }
  }

  function closePopup(root, persistSession) {
    if (!root) return;
    root.classList.remove(OPEN_CLASS);
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('hidden', '');
    unlockScroll();
    if (persistSession) {
      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (_) {}
    }
  }

  function init() {
    const root = document.getElementById('chic-newsletter-popup');
    if (!root) return;

    if (shouldMarkSubmittedFromUrl()) {
      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (_) {}
      return;
    }

    if (isDesignMode()) return;

    try {
      if (sessionStorage.getItem(STORAGE_KEY)) return;
    } catch (_) {}

    const hasErrors = root.querySelector('[data-newsletter-popup-errors]');
    if (hasErrors) {
      openPopup(root);
      return;
    }

    setTimeout(() => openPopup(root), OPEN_DELAY_MS);

    const closeBtn = root.querySelector('[data-newsletter-popup-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => closePopup(root, true));
    }

    root.addEventListener('click', (e) => {
      if (e.target === root) closePopup(root, true);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (!root.classList.contains(OPEN_CLASS)) return;
      closePopup(root, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
